import { useSaveData } from '@entities/common/savedData/index.ts';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type DescriptionEditorData = {
  value: string;
  onSubmit?: () => void;
};
export const useDescriptionEditor = (hash?: string) => {
  const n = useNavigate();

  const { data, doRemoveStorageData, doSetStorageData } = useSaveData<DescriptionEditorData>(
    `descriptionEditorHash_${hash}`
  );

  const redirectToDescriptionEditorPage = useCallback(
    (pageTitle?: string) => n(`/common/descriptionEditor/${hash}`, { state: { title: pageTitle } }),
    [n, hash]
  );

  const setData = useCallback(
    (data: DescriptionEditorData) => {
      doSetStorageData(data);
    },
    [doSetStorageData]
  );

  const setValue = useCallback(
    (value: string) => {
      doSetStorageData({ value });
    },
    [doSetStorageData]
  );

  const redirectToDescriptionEditorPageWithSetData = useCallback(
    (data: DescriptionEditorData) => {
      setData(data);
      redirectToDescriptionEditorPage();
    },
    [redirectToDescriptionEditorPage, setData]
  );

  return {
    value: data?.value || '',
    onSubmit: data?.onSubmit,
    setValue: setValue,
    clearStorage: doRemoveStorageData,
    redirectToDescriptionEditorPage,
    redirectToDescriptionEditorPageWithSetData,
  };
};
